@import '../../../theme.scss';

verdocs-search-box {
  font-family: $verdocs-primary-font;

  form {
    display: flex;
    flex-direction: row;
    height: 45px;
    box-sizing: border-box;
    margin: 5px 0 0;
    border-radius: 5px;
    align-items: center;
    background-color: #fff;
    padding: 0 8px;
    border-width: 1px;
    border-style: solid;
    border-color: $verdocs-light-blue;

    input {
      box-sizing: border-box;
      height: 43px;
      width: 100%;
      font-size: 18px;
      border: none;

      &:focus {
        outline: none;
      }
    }

    button.search {
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-radius: 4px;
      border: none;
      width: 100px;
      height: 28px;
      font-weight: 700;
      font-size: 10px;
      letter-spacing: 1px;
      background-color: $verdocs-green;
      text-transform: uppercase;
      color: #fff;
    }

    .type {
      background-color: $verdocs-light-blue;
      height: 30px;
      display: inline-flex;
      padding: 1px 0 2px 10px;
      font-size: 13px;
      line-height: 16px;
      border-radius: 4px;
      justify-content: center;
      text-transform: uppercase;
      align-items: center;
      flex-direction: row;
      color: #fff;
      margin-right: 10px;

      button {
        border: none;
        color: #fff;
        margin: 5px 0 0 8px;
        background: transparent;
      }
    }

    svg {
      width: 12px;
      height: 12px;
      margin-right: 6px;
    }
  }

  ::placeholder {
    color: $verdocs-grey-2;
  }
}
